/**
 * AVANT browser-tab presence treatment.
 * Changes only the document title and favicon while the page is hidden.
 */
(() => {
  const script = document.currentScript;
  if (!script || window.__avantTabPresenceInitialized) return;

  window.__avantTabPresenceInitialized = true;

  const hiddenPrimary = script.dataset.hiddenPrimary || '✦ Your edit awaits';
  const hiddenSecondary = script.dataset.hiddenSecondary || 'AVANT BUDAPEST';
  const faviconLinks = [...document.querySelectorAll('link[data-avant-favicon]')];
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  let activeTitle = document.title;
  let hiddenFrame = 0;
  let cycleTimer;
  let hiddenStateActive = false;

  const clearCycle = () => {
    if (cycleTimer) window.clearInterval(cycleTimer);
    cycleTimer = undefined;
  };

  const setFaviconState = (state) => {
    const attribute = state === 'away' ? 'awayHref' : 'defaultHref';

    faviconLinks.forEach((link) => {
      const href = link.dataset[attribute];
      if (href) link.href = href;
    });
  };

  const showHiddenFrame = () => {
    document.title = hiddenFrame % 2 === 0 ? hiddenPrimary : hiddenSecondary;
    hiddenFrame += 1;
  };

  const enterHiddenState = () => {
    if (hiddenStateActive) return;

    activeTitle = document.title;
    hiddenStateActive = true;
    hiddenFrame = 0;
    setFaviconState('away');
    showHiddenFrame();

    if (!reducedMotionQuery.matches && hiddenSecondary) {
      cycleTimer = window.setInterval(showHiddenFrame, 3200);
    }
  };

  const leaveHiddenState = () => {
    if (!hiddenStateActive) return;

    clearCycle();
    document.title = activeTitle;
    setFaviconState('default');
    hiddenStateActive = false;
  };

  const syncVisibilityState = () => {
    if (document.visibilityState === 'hidden') {
      enterHiddenState();
    } else {
      leaveHiddenState();
    }
  };

  document.addEventListener('visibilitychange', syncVisibilityState);
  window.addEventListener('pageshow', syncVisibilityState);
  window.addEventListener('pagehide', () => {
    clearCycle();
    if (hiddenStateActive) {
      document.title = activeTitle;
      setFaviconState('default');
      hiddenStateActive = false;
    }
  });

  syncVisibilityState();
})();
